// src/pages/ConversationsPage.js
// Standalone Conversations page — renders ConversationsPanel with full layout and immersive mobile support.

import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import useAuthHook from "../hooks/useAuth";
import ConversationsPanel from "../components/Layout/ConversationsPanel";

export default function ConversationsPage() {
  const { role } = useAuthHook();
  const [mobileView, setMobileView] = useState("list");

  useEffect(() => {
    document.body.classList.add("page-conversations");
    return () => {
      document.body.classList.remove("page-conversations");
    };
  }, []);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <ConversationsPanel
        role={role}
        onMobileViewChange={setMobileView}
      />
    </Box>
  );
}
